import React from "react";

/** Closes the dialog/sheet that provides this context. */
export type ClosePortal = () => void;

const PortalContext = React.createContext<ClosePortal | undefined>(undefined);

export const usePortalContext = (): ClosePortal => {
	const context = React.useContext(PortalContext);

	if (!context) throw new Error("Use within a sheet or modal");

	return context;
};

export default PortalContext;
